import { AddLight, ChooseRow, CopyAltLight, Paste, TrashLight } from '@repo/go-icons';
import { Button, RadioButtonGroup, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { IconButton } from '../../../shared/components/IconButton/IconButton';
import { Toolbar, ToolbarItem, ToolbarSeparator } from '../../components/Toolbar/Toolbar';
import { ViewSelector } from '../../components/ViewSelector';
import type { ViewStore } from '../../stores/ViewStore';
import type { WidgetView } from '../../types';

type AlertRulesTableToolbarProps = {
  viewStore: ViewStore;
  onDelete?: () => void;
  onCopy?: () => void;
  onPaste: () => void;
  onAdd?: () => void;
  onChooseRow?: () => void;
};
export const AlertRulesTableToolbar = observer(function AlertRulesTableToolbar({
  viewStore,
  onDelete,
  onCopy,
  onPaste,
  onAdd,
  onChooseRow,
}: AlertRulesTableToolbarProps) {
  const { t } = useTranslation();
  const editing =
    viewStore.current.name === 'alertRulesTime' || viewStore.current.name === 'alertRulesDepth'
      ? viewStore.current.view.service.uiState.editing
      : false;
  return (
    <Toolbar>
      <ToolbarItem>
        <ViewSelector viewStore={viewStore} disabled={editing} />
      </ToolbarItem>
      <ToolbarSeparator />
      <ToolbarItem>
        <RadioButtonGroup
          items={[
            {
              label: t('alertsManagerWidget:time'),
              value: 'alertRulesTime',
              disabled: viewStore?.current.name === 'alertRulesDepth' && editing,
            },
            {
              label: t('alertsManagerWidget:depth'),
              value: 'alertRulesDepth',
              disabled: viewStore?.current.name === 'alertRulesTime' && editing,
            },
          ]}
          value={viewStore.current.name}
          onChange={(value: WidgetView) => viewStore.select(value)}
        />
      </ToolbarItem>
      {editing && (
        <>
          <ToolbarItem toRight>
            {onCopy && (
              <Tooltip title={t('alertsManagerWidget:copy')} delay={400}>
                <div>
                  <IconButton icon={<CopyAltLight />} onClick={onCopy} />
                </div>
              </Tooltip>
            )}
          </ToolbarItem>
          <ToolbarItem>
            {onPaste && (
              <Tooltip title={t('alertsManagerWidget:paste')} delay={400}>
                <div>
                  <IconButton icon={<Paste />} onClick={onPaste} />
                </div>
              </Tooltip>
            )}
          </ToolbarItem>
          <ToolbarSeparator />
          <ToolbarItem>
            {onAdd && (
              <Button onClick={() => onAdd?.()} icon={<AddLight />}>
                {t('alertsManagerWidget:add')}
              </Button>
            )}
          </ToolbarItem>
          <ToolbarItem>{onDelete && <Button variant="danger" icon={<TrashLight />} onClick={onDelete} />}</ToolbarItem>
        </>
      )}
      {editing === false && (
        <ToolbarItem toRight>{onChooseRow && <Button icon={<ChooseRow />} onClick={onChooseRow} />}</ToolbarItem>
      )}
    </Toolbar>
  );
});
